import { ApolloQueryResult } from '@apollo/client';
import React from 'react';
import InvoiceGroupsTable from './invoice-groups-table';
import ShipToPartiesTable from './ship-to-parties-table';
import { PaymentMethodsTable } from '@css-xp/base/common-tabs';
import { CommerceAddress } from '@css-xp/graphtypes';

interface InvoiceGroupsTabProps {
  label: string;
  disabled?: boolean;
  transactionAccountId?: string;
  billToAddress?: CommerceAddress | null;
  onComplete?: () => Promise<ApolloQueryResult<unknown>>;
}

const InvoiceGroupsTab = ({ transactionAccountId, billToAddress, onComplete }: InvoiceGroupsTabProps) => {
  return (
    <div className="invoice-groups-tab" data-testid="transaction-account-invoice-groups">
      <InvoiceGroupsTable transactionAccountId={transactionAccountId} />
      <ShipToPartiesTable
        transactionAccountId={transactionAccountId}
        billToAddress={billToAddress}
        refetch={onComplete}
      />
      <PaymentMethodsTable transactionAccountId={transactionAccountId} refetch={onComplete} />
    </div>
  );
};

export default InvoiceGroupsTab;
